import { z } from '@harvestiq/zod';
import { dbApiKeySchema } from './db-api-key';

export const updateApiKeyRequestSchema = z.object({
  label: z.string().optional(),
  enabled: z.boolean().optional(),
});
export type UpdateApiKeyRequest = z.infer<typeof updateApiKeyRequestSchema>;

export const updateApiKeyRequestParamsSchema = z.object({
  apiKeyId: z.string().uuid(),
});
export type UpdateApiKeyRequestParams = z.infer<
  typeof updateApiKeyRequestParamsSchema
>;

export const updateApiKeyResponseSchema = z.object({
  data: z.array(dbApiKeySchema),
});
export type UpdateApiKeyResponse = z.infer<typeof updateApiKeyResponseSchema>;

export const updateApiKeyErrorResponseSchema = z.object({
  data: z.tuple([]),
  errors: z.array(z.object({ message: z.string() })),
});
